module.exports = __webpack_public_path__ + "img/reden-ist-gold.4511caff.jpg";